import GolfInfo from './GolfInfo'

export default GolfInfo
